import { ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

interface IContentContainer {
  children: ReactNode;
  isCenter?: boolean;
  isFill?: boolean;
}

export function CreateUserContentContainer({ children, isCenter = false, isFill = false }: IContentContainer) {
  return (
    <div
      className={twMerge(
        'flex bg-primary shadow-100 rounded-200 overflow-auto h-[calc(100vh_-_95px)]',
        isCenter && 'items-center justify-center md:min-h-[600px] lg:min-h-[700px]',
      )}
    >
      <div className={twMerge('flex flex-col gap-6', isFill && 'w-full h-full')}>{children}</div>
    </div>
  );
}
